// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24KhR","index":"styles_index__2B6zN"};